import React, {useEffect, useState} from 'react'
import {Button, Card, Col, Form, Modal, Row} from 'antd'
import {DeleteIco, ModalCloseIco, RefreshIco, SaveBlueIco} from '../../../modules/CustomIcons'

import './index.scss'
import {trnTypes} from "../../../root/Routes/Routes";
import {useHistory, useLocation} from "react-router-dom";
import InputField from "components/InputField";
import OwnAccount from "pages/Transfer/components/TransferBanks/OwnAccount";
import DeleteTemplate from "components/DeleteTemplate";
import {upsertTemplate} from "../../services/Transfers/Templates";
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import OtherAccount from "pages/Transfer/components/TransferBanks/OtherAccount";
import Azips from "pages/Transfer/components/TransferDomestic/Azips";
import Hoks from "pages/Transfer/components/TransferDomestic/Hoks";
import Edv from "pages/Transfer/components/TransferDomestic/Edv";
import CurrencyTransactions from "pages/Transfer/components/ForeignCurrency/CurrencyTransactions";
import Rub from "pages/Transfer/components/ForeignCurrency/Rub";
import Dxa from "pages/Transfer/components/TransferDomestic/Dxa";
import { useTranslation } from 'react-i18next';
import QeyriBudce from "pages/Transfer/components/AniPay/QeyriBudce";
import AnipayDxa from 'pages/Transfer/components/AniPay/Dxa'
import AnipayEDV from 'pages/Transfer/components/AniPay/Edv'

const EditTemplateModal: React.FC<any> = (props : any) => {
    const {t} = useTranslation();
    const [deleteTemplateModalVisible, setDeleteTemplateModalVisible] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [selectedTemplates, setSelectedTemplates]=useState<any>([]);
    const [subFormElements, setSubFormElements]=useState<any>(null);
    const [pmtCurr,setPmtCurr] = useState('')
    const [childform,setchildForm] = useState('')
    const templateData=props.templateData;
    const [form] = Form.useForm();
    const location=useLocation();
    const history=useHistory();
    const [validate, setValidate]=useState(true);
  
    

    useEffect(() => {

        setSelectedTemplates(old_data => [templateData.templateId])


        history.push({
            state: templateData
        })

    }, [])

    const onClose = () => {
        props.onClose((old_value) => false)
        setShowSuccessModal(old_data => false)
    }

    const closeAndUpdateList = () => {
        onClose();

        props.callBackApi();
    }

    useEffect(()=>{
        console.log(pmtCurr)
        getFormElements(childform,pmtCurr)
    },[pmtCurr])
    
    const getFormElements = (childForm : any,pmtCurr?:any) => {

        setchildForm(childForm)
        // setPmtCurr(pmtCurr)
       let list =[]
    //    const response = childForm.getFieldsValue()
               childForm.form?.validateFields().then(success_input_list => {
                console.log(success_input_list)
            if(success_input_list?.errorFields?.length > 0)
                setValidate(false)
            else
                setValidate(true)

            setSubFormElements([])
          
            for(let input_name in success_input_list){
                // list.push({
                //     [input_name]:success_input_list[input_name],
                //     transferDocs:templateData.trnData.transferDocs
                // })
                setSubFormElements(old_data => {
                    return {...old_data, [input_name] : success_input_list[input_name]}
                });
                
            }
        }).catch(err_input_list => {
            if(err_input_list?.errorFields?.length > 0)
                setValidate(false)
            else
                setValidate(true)
            let values= err_input_list.values

            setSubFormElements([])
            for(let input_name in values){
             
                setSubFormElements(old_data => {
                    return {...old_data, [input_name] : values[input_name]}
                });
            }


        });
    }

    const updateTemplate = (values: any) => {
//   console.log("erererere", templateData);
  console.log("pmtcur", pmtCurr);

  if (subFormElements !== null) {
    // clone and add pmtCurr
    const updatedSubForm = {
      ...subFormElements,
           pmtCurr:  pmtCurr || templateData?.pmtCurr,
    };

    const req_data = {
      templateId: templateData.templateId,
      templateName: values.templateName,
      trnType: templateData.trnType,
      isFavorite: templateData.isFavorite,
      trnData: updatedSubForm,
    };

    if (validate) {
      upsertTemplate(req_data).then((res) => {
        history.push({
          state: req_data,
        });

        setSubFormElements(null);
        setShowSuccessModal(true);
        props.callBackApi();
      });
    }
  } else {
    setShowSuccessModal(true);
  }
};


    const templatePage = (type) => {
        switch (type) {
            case "OWN_ACCOUNT":
                return <OwnAccount getFormElements={getFormElements} key={templateData.templateId}
                                   addOrEditPage={true}/>
            case "INTERNAL":
                return <OtherAccount getFormElements={getFormElements} key={templateData.templateId}
                                   addOrEditPage={true}/>
            case "AZIPS":
                return <Azips getFormElements={getFormElements} key={templateData.templateId}
                                     addOrEditPage={true}/>
            case "XOHKS":
                return <Hoks getFormElements={getFormElements} key={templateData.templateId}
                              addOrEditPage={true}/>
            case "DXA":
                return <Dxa getFormElements={getFormElements} key={templateData.templateId}
                             addOrEditPage={true}/>
            case "EDV":
                return <Edv getFormElements={getFormElements} key={templateData.templateId}
                             addOrEditPage={true}/>
            case "SWIFT":
                return <CurrencyTransactions getFormElements={(form,pmtCurr)=>{setPmtCurr(form.pmtCurr);getFormElements(form,form.pmtCurr)}} key={templateData.templateId}
                            addOrEditPage={true}/>
            case "SWIFT_RUB":
                return <Rub getFormElements={(form)=>getFormElements(form)} key={templateData.templateId}
                                             addOrEditPage={true}/>
            case "IPS_OTH":
                return <QeyriBudce getFormElements={getFormElements} key={templateData.templateId}
                              addOrEditPage={true} />
            case "IPS_BDG":
                return<AnipayDxa getFormElements={getFormElements} key={templateData.templateId}
                           addOrEditPage={true}/>
            case "IPS_VAT":
                return<AnipayEDV getFormElements={getFormElements} key={templateData.templateId}
                           addOrEditPage={true}/>
        }
    }

  return (
    <>
        {
            !showSuccessModal &&
            <Modal
                title={templateData.templateName}
                closeIcon={<ModalCloseIco />}
                centered
                visible={props.visible}
                onCancel={onClose}
                width={'60%'}
                className={`manage_faster_menus edit_template_modal no_footer  ${props?.className}`}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={false}
                bodyStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
            >

                <div className={'full flex direction_column edit_template_body'} >
                    <h3>{trnTypes[templateData.trnType].title}</h3>

                    {/*<ul className={'edit_temp_dates flex'} >*/}
                    {/*    <li>Şablonu yaratdı <strong>yusifh, 01.09.2018 13:13</strong></li>*/}
                    {/*    <li>Şablonu yenilədi <strong>samire, 25.10.2018 17:19</strong></li>*/}
                    {/*</ul>*/}

                    <Row>
                        <Col flex={'800px'} className="edit_template_col">
                            <Card bordered={false}>
                                <Row justify='start' className="edit_template_form">

                                    <Form
                                        labelCol={{ flex: '190px'}}
                                        wrapperCol={{ flex: 1 }}
                                        className='full OWN_ACCOUNT'
                                        onSubmit={(e) => e.preventDefault(e)}
                                        onFinish={updateTemplate}
                                        id={'form'}
                                        form={form}
                                        autoComplete="off"
                                    >

                                        <InputField
                                            labelItem={t("transfers.templateName")}
                                            placeholder=""
                                            name={'templateName'}
                                            required={true}
                                            form={form}
                                            value={templateData.templateName}
                                            message={true}
                                            // allowLatinWithSomeSymbols={true}
                                        />
                                        {
                                            templatePage(templateData.trnType)

                                        }
                                        <div  className='flex button_row justify_between' >
                                            <Button
                                                size={'large'}
                                                icon={<DeleteIco />}
                                                className="light-button btn save_btn flex align_center justify_center delete_temp_btn"
                                                htmlType={"button"}
                                                onClick={() => setDeleteTemplateModalVisible(old_data => true)}
                                            >
                                                {t("home.deleteTemplate")}
                                            </Button>

                                            <div className={'flex flex_wrap'}>

                                                <Button
                                                    size={'large'}
                                                    htmlType="submit"
                                                    className="blue-button next_btn btn flex align_center justify_center"
                                                >
                                                    {t("transfers.save")}
                                                </Button>


                                            </div>

                                        </div>

                                    </Form>

                                </Row>
                            </Card>
                        </Col>
                    </Row>


                </div>


            </Modal>
        }

        {
            deleteTemplateModalVisible && <DeleteTemplate
                visible={deleteTemplateModalVisible}
                onClose={setDeleteTemplateModalVisible}
                templateIds={selectedTemplates}
                callBackApi={closeAndUpdateList}
            />
        }

        {
            showSuccessModal && <SuccessOrErrorModal
                visible={showSuccessModal}
                onCancel={onClose}
                modalType={'success'}
                modalTitle={t("notification.attention")}
                modalText={t("notification.updatedTemplate")}
                // className={'template_update_success'}
                // width={500}
                modalFooter={true}
            />
        }
    </>
  )
}

export default EditTemplateModal
